export default "__VITE_ASSET__1S5wH0AK__"